<template>
  <div class="card floating" id="create-unit">
    <button class="button button-close"
      @click="$store.commit('closeHovers')"
      :aria-label="$t('buttons.close')"
      :title="$t('buttons.close')">
      <x-icon size="1.5x" class="custom-class"></x-icon>
    </button>
    <h2>{{ $t('buttons.manageAccess') }}</h2>
    <div v-if="isReady" ref="list-users" class="input-users">
      <shared-user v-for="(user, index) in users" :key="user.handle" v-bind:handle="user.handle" v-bind:name="user.name" v-bind:accesslevel="user.accesslevel" v-bind:contactsSelected="contactsSelected" 
      v-bind:index="index" @update-value="updateValue" @remove-user="removeUser" @select-contact="selectContact" @scroll-users="scrollUsers"></shared-user>
    </div>
    <button id="addButton" @click="addUser()" :aria-label="$t('sharedDrive.addAnotherUser')" :title="$t('sharedDrive.addAnotherUser')" :disabled="isDisabled">
      <plus-circle-icon size="1.5x" class="custom-class"></plus-circle-icon>
      <span>{{ $t('sharedDrive.addAnotherUser') }}</span>
    </button>
    <div class="access-link">
      <h3>{{ $t('sharedDrive.accessPublicLink') }}</h3>
      <div class="access">
        <div style="display: flex; align-items: center; font-size: 12px; margin-right: 30px;">
          <eye-icon size="1.5x" class="custom-class"></eye-icon>
          <p v-if="!read">{{ $t('sharedDrive.onlyReaderAccess') }}<b class="disabled">{{ $t('sharedDrive.disabled') }}</b></p>
          <p v-else>{{ $t('sharedDrive.onlyReaderAccess') }}<b>{{ $t('sharedDrive.enabled') }}</b></p>
        </div>
        <div class="buttons">
          <button v-if="read" id="copyLink" @click="copyLinkRead" :aria-label="$t('buttons.copyLink')" :title="$t('buttons.copyLink')">
            <span v-if="!isMobile">{{ $t('buttons.copyLink') }}</span>
            <copy-icon v-else size="1.5x" class="custom-class"></copy-icon>
          </button>
          <button v-if="read" id="disableAccess" @click="disableAccessRead" :aria-label="$t('buttons.disableAccess')" :title="$t('buttons.disableAccess')">
            <span v-if="!isMobile">{{ $t('buttons.disableAccess') }}</span>
            <trash-2-icon v-else size="1.5x" class="custom-class"></trash-2-icon>
          </button>
          <button v-if="!read" id="disableAccess" @click="enableAccessRead" :aria-label="$t('buttons.enableAccess')" :title="$t('buttons.enableAccess')">
            <span v-if="!isMobile">{{ $t('buttons.enableAccess') }}</span>
            <span v-else>{{ $t('buttons.trigger') }}</span>
          </button>
        </div>
      </div>
      <div class="access">
        <div style="display: flex; align-items: center; font-size: 12px; margin-right: 30px;">
          <edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>
          <p v-if="!write">{{ $t('sharedDrive.writeAccess') }}<b class="disabled">{{ $t('sharedDrive.disabled') }}</b></p>
          <p v-else>{{ $t('sharedDrive.writeAccess') }}<b>{{ $t('sharedDrive.enabled') }}</b></p>
        </div>
        <div class="buttons">
          <button v-if="write" id="copyLink" @click="copyLinkWrite" :aria-label="$t('buttons.copyLink')" :title="$t('buttons.copyLink')">
            <span v-if="!isMobile">{{ $t('buttons.copyLink') }}</span>
            <copy-icon v-else size="1.5x" class="custom-class"></copy-icon>
          </button>
          <button v-if="write" id="disableAccess" @click="disableAccessWrite" :aria-label="$t('buttons.disableAccess')" :title="$t('buttons.disableAccess')">
            <span v-if="!isMobile">{{ $t('buttons.disableAccess') }}</span>
            <trash-2-icon v-else size="1.5x" class="custom-class"></trash-2-icon>
          </button>
          <button v-if="!write" id="disableAccess" @click="enableAccessWrite" :aria-label="$t('buttons.enableAccess')" :title="$t('buttons.enableAccess')">
            <span v-if="!isMobile">{{ $t('buttons.enableAccess') }}</span>
            <span v-else>{{ $t('buttons.trigger') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="botones">
      <button id="cancelButton" @click="$store.commit('closeHovers')" :aria-label="$t('buttons.cancel')" :title="$t('buttons.cancel')">
        <span>{{ $t('buttons.cancel') }}</span>
      </button>
      <button id="openButton" @click="grantAccess" :aria-label="$t('buttons.accept')" :title="$t('buttons.accept')">
        <span>{{ $t('buttons.accept') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import { XIcon, PlusCircleIcon, Edit3Icon, EyeIcon, CopyIcon, Trash2Icon } from 'vue-feather-icons';
import SharedUser from '@/components/shared-drive/SharedUser.vue';

export default {
  name: 'manage-access',
  data: function () {
    return {
      users: [' '],
      contacts: [],
      contactsSelected: [],
      isReady: false,
      read: false,
      write: false,
      handle: '',
      linkRead: '',
      linkWrite: '',
      isDisabled: true
    };
  }, 
  components: {
    XIcon,
    PlusCircleIcon,
    SharedUser,
    Edit3Icon,
    EyeIcon,
    CopyIcon,
    Trash2Icon
  },
  async mounted () {
    window.addEventListener('keydown', this.keyEvent);
    this.setIsPrompt(true);

    if (this.selectedCount === 0) {
      this.handle = this.$route.hash.replace('#', '');
    } else {
      this.handle = this.req.items[this.selected[0]].handle;
    }
    
    let action = await ibb.getSharedDriveInfo(this.handle);
    this.users = action.accountPermissions.filter(item => item.handle !== '').map(user => ({handle: user.handle, name: user.name, accesslevel: user.accesslevel}));
    if (this.users.length === 0) {
      this.users.push('');
    } 

    //Comprobación de si existen los links 
    for (let user of action.accountPermissions) {
      if (user.handle === '' && user.accesslevel === 1) {
        this.linkRead = user.name;
        this.read = true;
      }
      if (user.handle === '' && user.accesslevel === 0) {
        this.linkWrite = user.name;
        this.write = true;
      }
    }

    this.isReady = true;

    let action2 = await ibb.getRootNode(Module.NodeType.CONTACT_ROOT.value);
    if (action2.error.type) {
      throw new Error('Error getting root node: ' +  action2.error.type);
    }
    const {nodeList} = await ibb.getChildren(action2.node.handle);
    let index = -1;
    for (let contact of nodeList) {
      if (contact.name === 'Contacto Externo') {
        index = nodeList.indexOf(contact);
      }
    }
    if (index > -1) {
      nodeList.splice(index, 1);
    }
    this.contacts = nodeList;
    this.obtenerListadoCompartidos();
  },
  beforeDestroy () {
    this.setIsPrompt(false);
    this.resetSelected();
    window.removeEventListener('keydown', this.keyEvent);
  },
  computed: {
    ...mapGetters(['selectedCount']),
    ...mapState(['selected', 'req']),
    isMobile () {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIsPrompt', 'resetSelected']),
    keyEvent (event) {
      // Enter
      if (event.keyCode === 13) {
        this.grantAccess();
      }
    },
    async grantAccess() {
      let action = await ibb.getSharedDriveInfo(this.handle);
      let accountPermissions = action.accountPermissions.filter(item => item.handle !== '');

      if (this.users.length > 0) {
        let flagError = false;
        if (accountPermissions.length > 0) {
          let flagError = false;
          for (let user2 of accountPermissions) { //Revocar accesos
            let flag = false;
            for (let user of this.users) {
              if (user2.name === user.name) {
                flag = true;
              }
            }
            if (!flag) {
              let action = await ibb.unshareDriveWithAccount(this.handle, user2.handle);
              if (action.error.type) {
                flagError = true;
              }
            }
          }
          if (flagError) {
            this.$showError(this.$t('sharedDrive.notRevoke'));
          }
        } 

        for (let user of this.users) {  //Conceder accesos
          if (user.name !== undefined) {
            let flag = false;
            let userHandle = '';
            for (let user2 of accountPermissions) {
              if (user.name === user2.name) {
                flag = true;
                if (user.accesslevel !== user2.accesslevel) {
                  userHandle = user2.handle;
                  flag = false;
                }
              }
            }

            if (!flag) {
              if (user.name.includes('https://iberbox.com')) {
                let action = await ibb.shareDriveWithAccountByLinkWithAccessLevel(this.handle, user.name, user.accesslevel);
                action = await ibb.getPublicAccountInfoByLink(user.name);
                let accountHandle = action.accountHandle;
                let name = action.name;
                await ibb.addContact(accountHandle, name);
              } else {
                for (let contact of this.contacts) {
                  if (contact.name === user.name || contact.accountHandle === userHandle) {
                    let action = await ibb.shareDriveWithAccountAndAccessLevel(this.handle, contact.accountHandle, user.accesslevel);
                    if (action.error.type) {
                      flagError = true;
                    }
                  }
                }
              }
            }
          }
        }
        if (flagError) {
          this.$showError(this.$t('sharedDrive.notShared'));
        }
      }
      
      this.$store.commit('closeHovers');
    },
    async addUser() {
      this.users = [...this.users, ''];
      await this.$nextTick();
      this.$refs['list-users'].scroll({
        top: this.$refs['list-users'].scrollHeight,
        behavior: 'smooth'
      });
      this.isDisabled = true;
    },
    async removeUser(index) {
      let i = this.contactsSelected.indexOf(this.users[index].name);
      this.contactsSelected.splice(i, 1);
      if (index !== 0) {
        this.users.splice(index, 1);
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    selectContact(contact) {
      this.contactsSelected.push(contact);
    },
    updateValue (val, index, accesslevel, handle) {
      const usuario = {
        handle: handle,
        name: val,
        accesslevel: accesslevel,
      };
      this.users[index] = usuario;
      if (val !== '' && val !== undefined) {
        this.isDisabled = false;
      } 
    },
    async obtenerListadoCompartidos() {
      let action = await ibb.getSharedDriveInfo(this.handle);
      for (let user of action.accountPermissions) {
        if (user.handle !== '') {
          this.contactsSelected.push(user.name);
        }
      }
    },
    copyLinkRead() {
      this.$store.commit('showHover', {prompt: 'share', message: this.linkRead});
    },
    async disableAccessRead() {
      await ibb.deleteLink(this.linkRead);
      this.read = false;
    },
    async enableAccessRead() {
      await ibb.createSharedDriveLink(this.handle, 1);
      let action = await ibb.getSharedDriveInfo(this.handle);
      for (let user of action.accountPermissions) {
        if (user.handle === '' && user.accesslevel === 1) {
          this.linkRead = user.name;
        }
      }
      this.read = true;
    },
    copyLinkWrite() {
      this.$store.commit('showHover', {prompt: 'share', message: this.linkWrite});
    },
    async disableAccessWrite() {
      await ibb.deleteLink(this.linkWrite);
      this.write = false;
    },
    async enableAccessWrite() {
      await ibb.createSharedDriveLink(this.handle, 0);
      let action = await ibb.getSharedDriveInfo(this.handle);
      for (let user of action.accountPermissions) {
        if (user.handle === '' && user.accesslevel === 0) {
          this.linkWrite = user.name;
        }
      }
      this.write = true;
    },
    async scrollUsers() {
      await this.$nextTick();
      this.$refs['list-users'].scroll({
        top: this.$refs['list-users'].scrollHeight,
        behavior: 'smooth'
      });
    }
  }
};
</script>